// Header.js
import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import bannerImage from './images/smart-banner-2.jpg';
import dataBannerImg from './images/synthetic_data_banner.jpg';
import hospitalityBannerImg from './images/hospitality.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase, faCoins, faUtensils, faChartLine, faLaptopCode } from '@fortawesome/free-solid-svg-icons';
import {Container} from "react-bootstrap";
import { faGear } from '@fortawesome/free-solid-svg-icons';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import MetaTags from './MetaTags';
const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay:true,
    autoplaySpeed:6000,
    slidesToShow: 1,
    pauseOnFocus: false, 
  pauseOnHover: false,
    slidesToScroll: 1
  };
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  
  return (
    <div>
    <header className="innr_header">
      
    </header>
    <div className="consultio_content">

    <MetaTags
        title="Business Consulting in Queensland | Smart Resources QLD"
        description="Empowering Queensland businesses with tailored solutions in synthetic data, angel investment, hospitality, management consulting, and software development."
        identifyUrl="https://smartresourcesqld.com.au/"
        DCTitle="Business Consulting in Queensland | Smart Resources QLD"
        DCDescription="Empowering Queensland businesses with tailored solutions in synthetic data, angel investment, hospitality, management consulting, and software development."
        DCSubject="Synthetic Data, Angel Investment, Hospitality, Management Consulting, Software Development"
        Canonical="https://smartresourcesqld.com.au/"
        ogImage={bannerImage}
        ogTitle="Business Consulting in Queensland | Smart Resources QLD"
        ogDescription="Empowering Queensland businesses with tailored solutions in synthetic data, angel investment, hospitality, management consulting, and software development."
        ogUrl="https://smartresourcesqld.com.au/"
      />
          <Slider {...settings} className="cont_partts">
            <div className="cont_carousel">
                <figure>
                  <img src={bannerImage} alt="banner" />
                </figure>
                <div className='banner_caption_holder'>
                    <div className="banner_caption">
                          <h2 className="wow fadeInUp"><span className="d-flex"><span className="discover">Discover  </span> <span className='smart'> Smart</span></span> <span className="resources">Resources</span></h2> 
                          <h3>Your Premier Consulting Partner in QLD</h3> 
                    </div>
                    <p>Unlocking Potential Across Industries</p>
                </div>
            </div>

            <div className="cont_carousel cont_car_overlay">
                <figure>
                  <img src={dataBannerImg} alt="banner" />
                </figure>
                <div className='banner_caption_holder cont_car_holder'>
                    <div className="banner_caption">
                          <h2 className="wow fadeInUp">Synthetic Data Services</h2> 
                          <h3>Generate statistically representative synthetic datasets securely. Train machine learning models without exposing real records, ensuring full data sovereignty and regulatory compliance.</h3> 
                    </div>
                </div>
            </div>

            <div className="cont_carousel cont_car_overlay">
                <figure>
                  <img src={hospitalityBannerImg} alt="banner" />
                </figure>
                <div className='banner_caption_holder cont_car_holder'>
                    <div className="banner_caption">
                          <h2 className="wow fadeInUp">Hospitality Operations</h2>
                          <h3>Managing premier hospitality business operations with a focus on exceptional customer service, service quality, and long-term sustainability.</h3>
                    </div>
                </div>
            </div>  
        </Slider>
      <div className="banner_bottom_partts ">
        <NavLink to="/operations/data-science-services-australia" className="banner_bottom_innr_partts" onClick={() => window.scrollTo(0, 0)}>
            <div className="item-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px', marginRight: '15px' }}>
                <FontAwesomeIcon icon={faDatabase} style={{ fontSize: '24px', color: '#7a0c2e' }} />
            </div>
            <div className="item--holder">
                <h3 className="item--title">Data Science Services</h3>
            </div>
        </NavLink>
        <NavLink to="/operations/angel-investor" className="banner_bottom_innr_partts" onClick={() => window.scrollTo(0, 0)}>
            <div className="item-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px', marginRight: '15px' }}>
                <FontAwesomeIcon icon={faCoins} style={{ fontSize: '24px', color: '#7a0c2e' }} />
            </div>
            <div className="item--holder">
                <h3 className="item--title">Angel Investor</h3>
            </div>
        </NavLink>
        <NavLink to="/operations/hospitality" className="banner_bottom_innr_partts" onClick={() => window.scrollTo(0, 0)}>
            <div className="item-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px', marginRight: '15px' }}>
                <FontAwesomeIcon icon={faUtensils} style={{ fontSize: '24px', color: '#7a0c2e' }} />
            </div>
            <div className="item--holder">
                <h3 className="item--title">Hospitality Operations</h3>
            </div>
        </NavLink>
        <NavLink to="/operations/management-consulting" className="banner_bottom_innr_partts" onClick={() => window.scrollTo(0, 0)}>
            <div className="item-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px', marginRight: '15px' }}>
                <FontAwesomeIcon icon={faChartLine} style={{ fontSize: '24px', color: '#7a0c2e' }} />
            </div>
            <div className="item--holder">
                <h3 className="item--title">Management Consulting</h3>
            </div>
        </NavLink>
        <NavLink to="/operations/software-web-development" className="banner_bottom_innr_partts" onClick={() => window.scrollTo(0, 0)}>
            <div className="item-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px', marginRight: '15px' }}>
                <FontAwesomeIcon icon={faLaptopCode} style={{ fontSize: '24px', color: '#7a0c2e' }} />
            </div>
            <div className="item--holder">
                <h3 className="item--title">Software & Web Dev</h3>
            </div>
        </NavLink>
      </div>
    </div>
    <section className="about_us_section">
      <div className="about_us_innr_sec">
   
      </div>
    </section>
   
  </div>
  );
};

export default Header;
